import { render, staticRenderFns } from "./DetailPopup.vue?vue&type=template&id=5af2d79a&scoped=true&"
import script from "./DetailPopup.vue?vue&type=script&lang=js&"
export * from "./DetailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2d79a",
  null
  
)

export default component.exports